import { deepClone } from '@/util/objects.js';

export const parseV2 = (data) => {
    setBans(data);
    const clone = deepClone(data);

    // if the timestamp is not in milliseconds yet, convert it
    if (clone.date_created.toString().length < 13) {
        [ 'date_created', 'date_followed', 'date_following', 'date_muted' ].forEach((key) => {
            if (clone[key]) {
                clone[key] *= 1000;
            }
        });
    }
    clone.date = clone.date_created;
    return clone;
};

export const parseV3 = (data) => {
    setBans(data);
    const clone = deepClone(data);
    clone.date_created *= 1000;
    clone.date = clone.date_created;
    return clone;
};

const setBans = (data) => {
    data.bans = Object.values(data.bans || {});
    const total_bans = data.bans.length;

    data.total_bans = total_bans;
};
